<template>
  <div />
</template>
<script>
// import request from '@/utils/request'
export default {
  created() {
    this.$router.replace('/home/index')
  }
}
</script>
